<script>
    export let collapsed = true;
    export let title = "";
    export let title_level="7";
</script>

<span class="is-clickable title is-{title_level}" on:click={() => collapsed = !collapsed}>
    {#if collapsed}
        [+]
    {:else}
        [-]
    {/if}

    <slot name="title">{title}</slot>
</span>

<div class:hidden={collapsed}>
    <slot></slot>
</div>